export default [
  {
    path: 'date',
    meta: {
      title: 'Event Dates',
      auth: ['Admin', 'Super Admin'],
      hidden: true
    },
    component: () => import('./pages/index'),
    redirect: 'date/list',
    children: [
      {
        path: 'list',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'List',
          resource: 'eventDate',
          icon: 'account_circle',
          hidden: true
        },
        component: () => import('./pages/list')
      },
      {
        path: 'edit/:id',
        meta: {
          auth: ['Admin', 'Super Admin'],
          title: 'Edit',
          resource: 'eventDate',
          icon: 'account_circle',
          hidden: true
        },
        component: () => import('./pages/edit')
      },
      {
        path: 'add',
        auth: ['Admin', 'Super Admin'],
        meta: {
          title: 'Add',
          resource: 'eventDate',
          icon: 'account_circle',
          hidden: true
        },
        component: () => import('./pages/add')
      }
    ]
  }
]
